import { isTradingDay } from '@/api';
import { setPathId, getPathId } from '@/utils/auth';


const common = {
  state: {
    addressTree: [],
    isDealDayStatus: false,
    pathId: getPathId()
  },
  mutations: {
    SET_ADDRESS: (state, value) => {
      state.addressTree = value;
    },
    SET_TRADING_DAY: (state, value) => {
      state.isDealDayStatus = value;
    },
    SET_PATH_ID: (state, value) => {
      state.pathId = value;
    }
  },
  actions: {
    // 校验交易时间
    isDealDayStatusFn({ commit }, value) {
      return new Promise((resolve, reject) => {
        isTradingDay().then((res) => {
          commit('SET_TRADING_DAY', true);
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },
    // 存放路径后缀id
    savePathId({ commit }, value) {
      setPathId(value);
      commit('SET_PATH_ID', value);
    }
  }
}

export default common
